import { apiService } from '../../shared/services/apiService';
import { ClientAnalyticsData } from '../interfaces/entity-dashboard/ClientAnalyticsData';
import { BestSellingRequest } from '../interfaces/entity-dashboard/BestSellingRequest';
import { BestSellingResponse } from '../interfaces/entity-dashboard/BestSellingResponse';
import { CoachPerformanceData } from '../interfaces/entity-dashboard/CoachPerformanceData';
import { DashboardFilterRequest } from '../interfaces/entity-dashboard/DashboardFilterRequest';
import { GrossRevenueData } from '../interfaces/entity-dashboard/GrossRevenueData';
import { OverviewData } from '../interfaces/entity-dashboard/OverviewData';
import { ScanAnalyticsData } from '../interfaces/entity-dashboard/ScanAnalyticsData';
import { ScanningPeakMatrixInfo } from '../interfaces/entity-dashboard/ScanningPeakMatrix';
import { ClientDemographicData } from '../interfaces/entity-dashboard/ClientDemographicData';
import { ClientDemographicRequest } from '../interfaces/entity-dashboard/ClientDemographicRequest';

type CoachPerformanceResponse = {
  coachPerformance: CoachPerformanceData[];
};

type CoachPerformanceRequest = DashboardFilterRequest & {
  itemCount: number;
};

export const entityDashboardService = {
  // Pre-creates the entity_customer_analytics row so the scan-analytics and
  // client-analytics requests don't race to create it on a new entity's first
  // dashboard load (constraint violation -> 500). See LMP-4850.
  async initCustomerAnalytics(): Promise<void> {
    const resp = await apiService.post<void>('/api/entity/customer-analytics');

    return resp.data;
  },

  async getOverviewData(filters: DashboardFilterRequest): Promise<OverviewData> {
    const resp = await apiService.post('/api/dashboard/overview', filters);

    return resp.data;
  },

  async getClientAnalytics(
    filters: DashboardFilterRequest,
  ): Promise<ClientAnalyticsData> {
    const resp = await apiService.post('/api/dashboard/client-analytics', filters);

    return resp.data;
  },

  async getBestSelling(filters: BestSellingRequest): Promise<BestSellingResponse> {
    const resp = await apiService.post('/api/dashboard/best-selling', filters);

    return resp.data;
  },

  async getScanningPeakMatrix(
    filters: DashboardFilterRequest,
  ): Promise<ScanningPeakMatrixInfo> {
    const resp = await apiService.post<ScanningPeakMatrixInfo>(
      '/api/dashboard/scanning-peak-hours',
      filters,
    );

    return resp.data;
  },

  async getGrossRevenueData(filters: DashboardFilterRequest): Promise<GrossRevenueData> {
    const resp = await apiService.post('/api/dashboard/gross-revenue', filters);

    return resp.data;
  },

  async getCoachPerformanceData(
    request: CoachPerformanceRequest,
  ): Promise<CoachPerformanceResponse> {
    const resp = await apiService.post('/api/dashboard/coach-performance', request);

    return resp.data;
  },

  async getScanAnalyticsData(
    filters: DashboardFilterRequest,
  ): Promise<ScanAnalyticsData> {
    const resp = await apiService.post('/api/dashboard/scan-analytics', filters);

    return resp.data;
  },

  async getClientDemographic(
    request: ClientDemographicRequest,
  ): Promise<ClientDemographicData> {
    const resp = await apiService.post('/api/dashboard/client-demographic', request);

    return resp.data;
  },
};
